<template>
    <body>
        <div class="header-fixed">
            <HeaderLayout/>
            <NavLayout/>
        </div>
        <main class="main-padding">
            <router-view></router-view>
        </main>
        <div ref="estimatorSlot"></div>
        <FooterLayout/>

    </body>
</template>
<script>
import HeaderLayout from './HeaderLayout'
import NavLayout from './NavLayout'
import FooterLayout from './FooterLayout'
import { useRoute } from 'vue-router'
import { watch, ref, nextTick } from 'vue'

export default {
  name: 'App',
  components: {
    HeaderLayout,
    NavLayout,
    FooterLayout
  },
  setup() {
    const route = useRoute()
    const estimatorSlot = ref(null)

    const toggleFloatingEstimator = () => {
      nextTick(() => {
        const el = document.getElementById('widget-floatingEstimator-mount')
        if (!el) return

        const isServicePage = route.path.startsWith('/service')
        el.style.display = isServicePage ? '' : 'none'

        // Move widget into the slot between main and footer
        if (isServicePage && estimatorSlot.value && !estimatorSlot.value.contains(el)) {
          estimatorSlot.value.appendChild(el)
        }

        // Override fixed positioning to sit inline
        const container = el.querySelector('[class*="floatingContainer"]')
        if (container && isServicePage) {
          container.style.position = 'static'
          container.style.display = 'flex'
          container.style.justifyContent = 'center'
          container.style.padding = '24px 0'
        }
      })
    }

    watch(() => route.path, toggleFloatingEstimator, { immediate: true })

    return { estimatorSlot }
  }
}
</script>